export enum MetaDataTypeEnum {
    Numero = 1,
    Texto = 2,
    Data = 3,
    Select = 4
}
